import { ConfirmationData } from "../../../../common/summary-common/confirmationData";

export const overWriteKeyPersonQuestionnaireInformation: Map<string, ConfirmationData> = new Map([
    // Q1: Hide empty "Cuestionario de persona clave" title section
    ["765f2b92-0161-4095-97db-6b1df16be8a5", { hidden: true }],

    // Q2: Hide empty "Cuestionario de persona clave" title section
    ["a1512a6e-3e7c-4004-8ce2-e0a86b22b8a1", { hidden: true }],

    // Q3: Hide "Cuestionario de persona clave" title section with hidden group
    ["36b1ec64-0b5e-47f6-8542-79913ecbdf7a", { hiddenAll: true }],

    // Q3: Relabel first content section to "Preguntas adicionales"
    ["186f3390-eba4-4352-b4bc-7b321db1a577", { label: "Preguntas adicionales" }],

    // Q3: Hide remaining section headers (keep their fields visible)
    ["06a7459d-3f5a-4187-a195-2b474eb8e49d", { hidden: true }],
    ["34efeb14-ecdd-4e43-b28d-376b8a5bb859", { hidden: true }],
    ["b5316a90-6bea-47cb-96d0-bc01fa197322", { hidden: true }],
    ["8de51a9a-d98c-4337-9da5-2b532aa95500", { hidden: true }],
    ["eaff576d-f4f2-451f-b82d-ad2682962465", { hidden: true }],
]);
